var loadMessgeListInterval;

import React from 'react';
import PropTypes from 'prop-types';
import createReactClass from 'create-react-class';
import { createConsumer } from '@rails/actioncable';

import MessageBoxList from './message_box_list';
import Loader from '../loader';
// import SideGroupArea from "./side_group_area";
import MessageSendForm from './message_send_form';
import ModalConfirm from '../modal/modal_confirm';
import ModalAlert from '../modal/modal_alert';

export default createReactClass({
  displayName: 'Root',
  propTypes: {
    event: PropTypes.object.isRequired,
  },
  getInitialState() {
    return {
      circle: {},
      loading: true,
      isPreviousLoading: false,
      isDisplayPreviousBtn: false,
      page: 1,
      messages: [],
      updatedMessages: [],
      maxMessageId: 0,
      calledAt: '',
      unreadMessageCount: 0,
      messageCount: 0,
      isFirstLoad: true,
      isSubmit: false,
      isCompany: this.props.isCompany ? this.props.isCompany : false,
      messageListPadding: 0,
      isWsConnected: true,
    };
  },
  loadMessageListFromServer() {
    $.ajax({
      url: '/api/message/event',
      dataType: 'json',
      cache: false,
      data: {
        event_id: this.props.event.id,
        max_message_id: this.state.maxMessageId,
        prev_called_at: this.state.calledAt,
      },
    })
      .done(
        function (data) {
          // success
          var updatedMessages = {};
          data.updatedMessages.forEach(function (message) {
            updatedMessages[message.id] = message;
          });
          let prevMessageId = 0;
          var messages = this.state.messages
            .concat(data.messages)
            .map(function (message) {
              if (prevMessageId !== message.id) {
                if (!updatedMessages[message.id]) return message;
                message = updatedMessages[message.id];
                prevMessageId = message.id;
                return message;
              }
            });
          var maxMessageId = data.maxMessageId
            ? data.maxMessageId
            : this.state.maxMessageId;
          if (
            data.circle.charge_plan_type > 0 &&
            data.messageCount > 100 &&
            this.state.page == 1
          ) {
            this.setState({
              isDisplayPreviousBtn: true,
            });
          }
          this.setState(
            {
              loading: false,
              circle: data.circle,
              messages: messages,
              maxMessageId: maxMessageId,
              calledAt: data.calledAt,
              messageCount: data.messageCount,
              unreadMessageCount: data.unreadMessageCount,
            },
            function () {
              if (this.state.isFirstLoad) {
                $('.flexContainer').innerHeight(window.innerHeight);
                this.scrollToBottom();
                this.setState({
                  isFirstLoad: false,
                });
              }

              if (this.state.isSubmit) {
                $('.containerMessage').height('');
                this.setState({
                  isSubmit: false,
                });
                this.scrollToBottom();
              }
            },
          );
        }.bind(this),
      )
      .fail(
        function () {
          // error
        }.bind(this),
      );
  },
  componentDidMount() {
    this.loadMessageListFromServer();
    $(window).on(
      'focus',
      function () {
        this.loadMessageListFromServer();
      }.bind(this),
    );

    this.consumer = createConsumer();
    this.subscription = this.consumer.subscriptions.create(
      { channel: 'EventMessageChannel', event_id: this.props.event.id },
      {
        connected: () => {
          this.setState({ isWsConnected: true });
          if (this.wasDisconnected) {
            this.loadMessageListFromServer();
            this.wasDisconnected = false;
          }
        },
        disconnected: () => {
          this.setState({ isWsConnected: false });
          this.wasDisconnected = true;
        },
        received: (data) => {
          this.handleWsReceived(data);
        },
      },
    );
  },
  componentWillUnmount() {
    clearInterval(loadMessgeListInterval);
    if (this.subscription) this.subscription.unsubscribe();
    if (this.consumer) this.consumer.disconnect();
  },
  handleWsReceived(data) {
    if (data.type === 'message_created') {
      const incoming = data.message;
      const clientId = data.client_id;
      let nextMessages = [...this.state.messages];

      if (clientId) {
        const idx = nextMessages.findIndex((m) => m.client_id === clientId);
        if (idx >= 0) {
          nextMessages[idx] = { ...incoming, status: 'sent' };
        } else if (!nextMessages.find((m) => m.id === incoming.id)) {
          nextMessages.push({ ...incoming, status: 'sent' });
        }
      } else {
        if (!nextMessages.find((m) => m.id === incoming.id)) {
          nextMessages.push({ ...incoming, status: 'sent' });
        }
      }

      this.setState({
        messages: nextMessages,
        maxMessageId: Math.max(this.state.maxMessageId || 0, incoming.id || 0),
      });
    } else if (data.type === 'read_status_changed') {
      const updated = this.state.messages.map((m) =>
        m.id === data.message_id
          ? { ...m, already_readers_count: data.already_readers_count }
          : m,
      );
      this.setState({ messages: updated });
    }
  },
  componentDidUpdate(prevProps, prevState) {
    var ancLatestMessage = this.ancLatestMessage;
    if (
      this.state.loading ||
      prevState.messages[prevState.messages.length - 1] === undefined ||
      this.state.messages[prevState.messages.length - 1] === undefined ||
      prevState.messages[prevState.messages.length - 1].body !==
        this.state.messages[this.state.messages.length - 1].body
    ) {
      if (window.innerWidth > 767) {
        // PC
        $('.block-messageList').scrollTop(ancLatestMessage.offsetTop);
      } else {
        // スマホ
        $('html, body').scrollTop(ancLatestMessage.offsetTop);
      }
    }
  },
  pauseLoading() {
    clearInterval(loadMessgeListInterval);
  },
  startLoading() {
    // ポーリング撤廃済み（WebSocket購読に置き換え）
  },
  handleMessageSubmit: function (message) {
    const clientId =
      typeof crypto !== 'undefined' && crypto.randomUUID
        ? crypto.randomUUID()
        : `cid_${Date.now()}_${Math.random().toString(36).slice(2)}`;

    const optimisticMsg = {
      client_id: clientId,
      id: null,
      body: message.body,
      sender_id: this.props.currentUser ? this.props.currentUser.id : null,
      status: 'sending',
      created_at: new Date().toISOString(),
      user: this.props.currentUser || {},
      messages_like_users: [],
      already_readers_count: 0,
    };

    this.setState({
      messages: [...this.state.messages, optimisticMsg],
      isSubmit: true,
    });

    const timeoutId = setTimeout(() => {
      const updated = this.state.messages.map((m) =>
        m.client_id === clientId ? { ...m, status: 'failed' } : m,
      );
      this.setState({ messages: updated });
    }, 10000);

    $.ajax({
      url: '/api/message/event_all_send',
      type: 'POST',
      headers: {
        'X-CSRF-Token': document.getElementsByName('csrf-token')[0].content,
      },
      data: {
        body: message['body'],
        event_id: this.props.event.id,
        parent_message_id: message['parent_message_id'],
        client_id: clientId,
      },
      cache: false,
      success: function () {
        // POST成功後も timeoutId はクリアしない。
        // WebSocket message_created を受信した時点で handleWsReceived がクリアする。
        // 10秒以内にWSが来なければタイムアウトで failed 化する（Redis障害等のフォールバック）。
      }.bind(this),
      error: function () {
        clearTimeout(timeoutId);
        const updated = this.state.messages.map((m) =>
          m.client_id === clientId ? { ...m, status: 'failed' } : m,
        );
        this.setState({ messages: updated, isSubmit: false });
      }.bind(this),
    });
  },
  handleLoadPreviousMessage() {
    var page = this.state.page;
    page++;
    if (this.state.messageCount < 100 * (page - 1)) {
      this.setState({
        isDisplayPreviousBtn: false,
      });
      return false;
    }

    this.setState({
      isPreviousLoading: true,
    });

    $.ajax({
      url: '/api/message/event',
      dataType: 'json',
      cache: false,
      data: {
        event_id: this.props.event.id,
        page: page,
        max_message_id: 0,
        prev_called_at: '',
      },
    })
      .done(
        function (data) {
          // success
          // var isDisplayPreviousBtn = false;
          var messages = data.messages.concat(this.state.messages);
          this.setState({
            isPreviousLoading: false,
            messages: messages,
            page: page,
          });
        }.bind(this),
      )
      .fail(
        function () {
          // error
        }.bind(this),
      );
  },
  setFile: function (file) {
    this.setState({
      file: file,
    });
  },
  openModal: function () {
    this.modalConfirm.openModal();
  },
  handlePhotoSubmit() {
    const clientId =
      typeof crypto !== 'undefined' && crypto.randomUUID
        ? crypto.randomUUID()
        : `cid_${Date.now()}_${Math.random().toString(36).slice(2)}`;

    const optimisticMsg = {
      client_id: clientId,
      id: null,
      body: '',
      sender_id: this.props.currentUser ? this.props.currentUser.id : null,
      status: 'sending',
      created_at: new Date().toISOString(),
      user: this.props.currentUser || {},
      messages_like_users: [],
      already_readers_count: 0,
      picture_medium: null,
    };

    this.setState({
      messages: [...this.state.messages, optimisticMsg],
      isSubmit: true,
    });

    const timeoutId = setTimeout(() => {
      const updated = this.state.messages.map((m) =>
        m.client_id === clientId ? { ...m, status: 'failed' } : m,
      );
      this.setState({ messages: updated });
    }, 10000);

    var formData = new FormData();
    formData.append('file', this.state.file);
    formData.append('event_id', this.props.event.id);
    formData.append('client_id', clientId);
    $.ajax({
      type: 'POST',
      headers: {
        'X-CSRF-Token': document.getElementsByName('csrf-token')[0].content,
      },
      url: '/api/message/event_all_send',
      cache: false,
      data: formData,
      processData: false,
      contentType: false,
    })
      .done(
        function () {
          // success: POST成功後も timeoutId はクリアしない。WS到着で handleWsReceived がクリアする。
        }.bind(this),
      )
      .fail(
        function () {
          // error
          clearTimeout(timeoutId);
          this.modalAlert.openModal();
          const updated = this.state.messages.map((m) =>
            m.client_id === clientId ? { ...m, status: 'failed' } : m,
          );
          this.setState({
            messages: updated,
            isSubmit: false,
            loading: false,
          });
        }.bind(this),
      );
  },
  handleRetryMessage(clientId) {
    const failed = this.state.messages.find(
      (m) => m.client_id === clientId && m.status === 'failed',
    );
    if (!failed) return;
    const updated = this.state.messages.map((m) =>
      m.client_id === clientId ? { ...m, status: 'sending' } : m,
    );
    this.setState({ messages: updated });
    this.handleMessageSubmit({ body: failed.body });
  },
  scrollToBottom() {
    var target = $('.block-messageList');
    if (window.innerWidth > 767) {
      $('html, body').scrollTop(target.height());
    } else {
      $('.containerMessage').scrollTop(target.height());
    }
  },
  setMessageListPadding(messageListPadding) {
    this.setState(
      {
        messageListPadding,
      },
      () => {
        this.scrollToBottom();
      },
    );
  },
  render() {
    var currentUserId = this.props.currentUser.id;

    let num = 0;
    let havePictureLength =
      this.state.messages.length > 0
        ? this.state.messages.filter((v) => v.picture_medium !== null).length
        : 0;
    var messageBoxList = this.state.messages.map(
      function (message) {
        if (message.picture_medium !== null) num++;
        return (
          <MessageBoxList
            message={message}
            currentUserId={currentUserId}
            isLastPictureMessage={
              message.picture_medium !== null && havePictureLength === num
            }
            key={message.id || message.client_id}
            onRetry={this.handleRetryMessage}
          />
        );
      }.bind(this),
    );

    var messageListAll = (
      <div
        className={`${
          window.innerWidth > 767 ? 'bg-gray h-main100vh' : ''
        } pb-5`}
        style={{ paddingBottom: this.state.messageListPadding }}
      >
        <div className="block-messageList container col-md-8 col-lg-6">
          <ul className="list-unstyled mb-2 pt-3">{messageBoxList}</ul>
          <Loader isActive={this.state.loading} />
          <div
            id="ancLatestMessage"
            ref={(c) => {
              this.ancLatestMessage = c;
            }}
          />
        </div>
      </div>
    );

    var reactRoot = '';

    if (!this.props.isSendDisabled) {
      if (window.innerWidth > 767) {
        // PC
        reactRoot = (
          <div className="react-root">
            {!this.state.isWsConnected && (
              <div
                className="ws-disconnected-banner alert alert-warning"
                style={{ padding: '8px', textAlign: 'center' }}
              >
                接続が切れています。再接続中...
              </div>
            )}
            <div>
              {messageListAll}
              <MessageSendForm
                onMessageSubmit={this.handleMessageSubmit}
                loadMessageListFromServer={this.loadMessageListFromServer}
                pauseLoading={this.pauseLoading}
                startLoading={this.startLoading}
                setFile={this.setFile}
                setMessageListPadding={this.setMessageListPadding}
                openModal={this.openModal}
                messageGroupId={this.props.messageGroupId}
              />
              <ModalConfirm
                ref={(c) => {
                  this.modalConfirm = c;
                }}
                title="画像の送信"
                content="よろしいですか？"
                approveFunc={this.handlePhotoSubmit}
              />
              <ModalAlert
                ref={(c) => {
                  this.modalAlert = c;
                }}
                title="画像の送信"
                content="画像の送信に失敗しました。"
              />
            </div>
          </div>
        );
      } else {
        // スマホ
        reactRoot = (
          <div className="reactRoot">
            {!this.state.isWsConnected && (
              <div
                className="ws-disconnected-banner alert alert-warning"
                style={{ padding: '8px', textAlign: 'center' }}
              >
                接続が切れています。再接続中...
              </div>
            )}
            <div className="bg-gray h-main100vh">
              {messageListAll}
              <MessageSendForm
                onMessageSubmit={this.handleMessageSubmit}
                loadMessageListFromServer={this.loadMessageListFromServer}
                pauseLoading={this.pauseLoading}
                startLoading={this.startLoading}
                setFile={this.setFile}
                setMessageListPadding={this.setMessageListPadding}
                openModal={this.openModal}
                messageGroupId={this.props.messageGroupId}
              />
              <ModalConfirm
                ref={(c) => {
                  this.modalConfirm = c;
                }}
                title="画像の送信"
                content="よろしいですか？"
                approveFunc={this.handlePhotoSubmit}
              />
              <ModalAlert
                ref={(c) => {
                  this.modalAlert = c;
                }}
                title="画像の送信"
                content="画像の送信に失敗しました。"
              />
            </div>
          </div>
        );
      }
    } else {
      reactRoot = (
        <div className="reactRoot">
          {!this.state.isWsConnected && (
            <div
              className="ws-disconnected-banner alert alert-warning"
              style={{ padding: '8px', textAlign: 'center' }}
            >
              接続が切れています。再接続中...
            </div>
          )}
          <div className="bg-gray h-main100vh">{messageListAll}</div>
        </div>
      );
    }

    return reactRoot;
  },
});

// var prevTargetScrollHeight;
